<script setup>
  import { onBeforeUnmount, onMounted, ref, watch } from "vue";
  import Multiselect from "vue-multiselect";
  import { bus } from "./bus";

  const props = defineProps({
    sorts: {
      type: Array,
      default: () => [],
      required: true,
    }
  });

  const emit = defineEmits(["update:sortOrder"]);

  const sortValue = ref(props.sorts.filter(sort => sort.selected )[0] || null);

  const sortOptions = ref(props.sorts);

  const trans = (key) => {
    return _.get(window.translations, key, key);
  };

  watch(sortValue, (newVal) => {
    if (newVal != null) {
      sortOptions.value.forEach(sort => {
        if (sort.value === newVal.value) {
          sort.selected = true;
        } else {
          sort.selected = false;
        }
      });
    }
    emit("update:sortOrder", newVal);
  });


  function localResetSearch() {
    sortOptions.value.forEach(sort => {
      sort.selected = false;
    });
    sortValue.value = null;
    emit("update:sortOrder", null);
  }

  onBeforeUnmount(() => bus.off('filters:reset', localResetSearch));
  onMounted(() => {
    bus.on('filters:reset', localResetSearch)
    const url = new URL(window.location.href);
    if (url.searchParams.has('order[name]')) {
      sortOptions.value.forEach(sort => {
        if (sort.value === url.searchParams.get('order[name]')) {
          sort.selected = true;
        } else {
          sort.selected = false;
        }
      });
      sortValue.value = sortOptions.value.filter(sort => sort.selected)[0];
    }

  });
</script>

<template>
  <div class="order-by-alpha-container">
    <multiselect
      v-model="sortValue"
      :options="sortOptions"
      :searchable="false"
      :allow-empty="true"
      label="name"
      track-by="value"
      placeholder="Order by Name..."
    >
      <template v-slot:singleLabel="{ option }">
        <span class="multiselect-label"><strong>{{ option.name }}</strong></span>
      </template>
      <template v-slot:placeholder>
        <span class="multiselect-label">{{ trans('Order by Name...') }}</span>
      </template>
    </multiselect>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

</style>
